<template>
  <div id="app">
		<router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {

  }
}
</script>

<style lang="less">
// 公共css
blockquote,body,button,dd,div,dl,dt,form,h1,h2,h3,h4,h5,h6,input,legend,li,ol,p,pre,td,textarea,th,tr,ul,div,span,em,view,text,a,i {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}
html,body{
	height: 100%;
}

a{
	color:#333; text-decoration:none;
}
a:hover{ 
	text-decoration:underline;
}

li,
ol,
ul {
	list-style: none outside none;
}
input,
select {
	outline: 0;
}

button:active,
a:active {
	opacity: 0.8;
}

.mt10 {
	margin-top: 10px !important;
}
.mt15 {
	margin-top: 15px !important;
}
.mt20 {
	margin-top: 20px !important;
}
.mt30 {
	margin-top: 30px !important;
}
.mt40 {
	margin-top: 40px !important;
}
.mt50 {
	margin-top: 50px !important;
}
.mt60 {
	margin-top: 60px !important;
}
.mt70 {
	margin-top: 70px !important;
}
.mt110 {
	margin-top: 110px !important;
}

.mb60 {
	margin-bottom: 60px !important;
}

.mr10 {
	margin-right: 10px !important;
}
.ml0 {
	margin-left: 0px !important;
}
.ml10 {
	margin-left: 10px !important;
}
.ml50 {
	margin-left: 50px !important;
}

.clear {
	clear: both;
}
.fl {
	float: left;
}
.fr {
	float: right;
}
.flx{
	display: flex;
}
.flr{
	display: flex;
	justify-content: right;
}
.fsb{
	display: flex;
	align-items: center;
	justify-content: space-between;
}

#app,
.app,
body,
main,
html,
template {
	color: #2f3c4d;
	font-size: 14px;
	width: 100%;
	height: 100%;
	position: relative;
	font-family: 'Microsoft YaHei', Arial, Helvetica, sans-serif, '宋体';
	/* overflow: hidden; */
}
button {
	cursor: pointer;
}

#app,.body{
	height: 100%;
	display: flex;
	flex-direction: column;
}
.content {
	width: 1380px;
	margin: 0 auto;
	position: relative;
}
.block{
	width: 100%;
	max-width: 1920px;
	margin: 0 auto;
	padding-bottom: 80px;
	flex: 1 0 auto;
}

.bg{
	width: 100%;
	background: #f2f3f5;
	padding: 90px 0;
}
.bg_01{
	width: 100%;
	background: #f6f6f6;
	padding: 70px 0;
}


::-webkit-scrollbar {
	/* 滚动条整体部分 */
	width: 6px;
	height: 6px;
}

::-webkit-scrollbar-button {
	/* 滚动条两端的按钮 */
	display: none;
}

::-webkit-scrollbar-track-piece {
	background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
	/* 滑块 */
	width: 6px;
	border-radius: 6px;
	background: #d9d9d9;
}

::-webkit-scrollbar-corner {
	/* 边角 */
	width: 6px;
}

::-webkit-scrollbar-thumb:hover {
	/* 鼠标移入滑块 */
	background: #909090;
}

header{
	flex: 0 0 auto;
}
footer{
	flex: 0 0 auto;
}

.current{
	color: #1265a4;
}
.select{
	color: #1265a4;
	border-bottom: 2px solid #1265a4;
}
.el-carousel__item{
	text-align: center;
}

.title_01{
	color: #000;
	font-size: 38px;
	text-align: center;
	width: 100%;
}
.banner_about{
	width: 100%;
	height: 650px;
	background: url('./images/banner_about.png') center no-repeat;
}
.banner_innovation{
	width: 100%;
	height: 650px;
	background: url('./images/banner_innovation.png') center no-repeat;
}
.banner_case{
	width: 100%;
	height: 650px;
	background: url('./images/banner_case.png') center no-repeat;
}
.banner_news{
	width: 100%;
	height: 650px;
	background: url('./images/banner_news.png') center no-repeat;
}
.banner_contact{
	width: 100%;
	height: 650px;
	background: url('./images/banner_contact.png') center no-repeat;
}

.menu_block {
	width: 100%;
	height: 98px;
	background: #f9f9f9;
	display: flex;
	align-items: center;
	.menu {
		display: flex;
		dd {
			display: flex;
		}
		a {
			font-size: 18px;
			height: 98px;
			line-height: 98px;
			margin-right: 70px;
		}
	}
	.menu_slt{
		display: flex;
		dd {
			font-size: 18px;
			height: 98px;
			line-height: 98px;
			margin-right: 70px;
			display: flex;
			cursor: pointer;
		}
	}

	.location {
		color: #999;
		height: 98px;
		background: url('./images/ico_05.png') left no-repeat;
		padding-left: 25px;
		display: flex;
		align-items: center;
		.icon {
			margin: 0 5px;
			padding-top: 3px;
		}
	}
}

.text_block{
	color: #000;
	font-size: 20px;
	width: 100%;
	line-height: 40px;
	text-indent: 2em;
	strong{
		color: #1265a4;
	}
	.img{
		width: 100%;
		display: flex;
		justify-content: center;
	}
}
.page_list{
	width: 100%;
	margin-top: 50px;
	display: flex;
	justify-content: center;
}
</style>
